// js/sections/featured-content-ghd.js
import { animate as animate17, timeline } from "vendor";
import { EffectCarousel, __accessCheck, __privateGet, __privateAdd, __privateSet, __privateMethod, throttle } from "theme";

var _adaptHeight, adaptHeight_fn, _onResize, onResize_fn, _setupListeners2, setupListeners_fn2;

var FeaturedContentGHD = class extends EffectCarousel {
	
  constructor() {
    super();
    __privateAdd(this, _setupListeners2);
	__privateAdd(this, _onResize);
    __privateAdd(this, _adaptHeight);
	
    __privateMethod(this, _setupListeners2, setupListeners_fn2).call(this);
	
    new ResizeObserver(__privateMethod(this, _onResize, onResize_fn).bind(this)).observe(this);
  }
  
  connectedCallback() {
	if (this.adaptiveHeight) {
      __privateMethod(this, _adaptHeight, adaptHeight_fn).call(this);
    }
  }
  
  get adaptiveHeight() {
    return this.hasAttribute("adaptive-height");
  }
  
  createOnChangeAnimationControls(fromSlide, toSlide) {
    return {
      leaveControls: () => this._getSlideEnteringSequence(toSlide, fromSlide),
      enterControls: () => this._getSlideLeavingSequence(toSlide, fromSlide)
    };
  }
  
  _getSlideEnteringSequence(toSlide, fromSlide) {
      let contentMode = true; 
	  if (contentMode) {
		  return animate17(fromSlide, { opacity: [1, 0], transform: ["translateY(0)", "translateY(15px)"] }, { duration: 0.3, easing: "ease-in" });
	  } else {
	      return timeline([
			  [toSlide, { opacity: [0, 1] }, { duration: 0.8, easing: [0.25, 0.46, 0.45, 0.94] }],
			  [toSlide.querySelectorAll(".content-over-media > :is(video-media, svg), .content-over-media > picture img"), { opacity: [0, 1], transform: ["scale(1.2)", "scale(1)"] }, { duration: 0.8, at: "<", easing: [0.25, 0.46, 0.45, 0.94] }],
			  [toSlide.querySelectorAll(".prose"), { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 0.6, at: "-0.4", easing: [0.215, 0.61, 0.355, 1], delay: slideContentDelay }],
			  [toSlide.querySelector(".featured-banner-image"), { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 0.6, at: "<", easing: [0.215, 0.61, 0.355, 1] }],
			  [toSlide.querySelector(".button-group"), { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0)"] }, { duration: 0.6, at: "<", easing: [0.215, 0.61, 0.355, 1] }]
		  ]);
	  }
  }
  
  _getSlideLeavingSequence(toSlide, fromSlide) {
      let contentMode = true; 
	  if (contentMode) {
		  return animate17(toSlide, { opacity: [0, 1], transform: ["translateY(15px)", "translateY(0)"] }, { duration: 0.2, delay: 0.2, easing: "ease-out" });
      } else {
		  return timeline([
			  [fromSlide.querySelectorAll(".prose"), { opacity: [1, 0], transform: ["translateY(0)", "translateY(10px)"] }, { duration: 0.25, at: "leaving", easing: [0.55, 0.055, 0.675, 0.19] }],
			  [fromSlide.querySelector(".featured-banner-image"), { opacity: [1, 0], transform: ["translateY(0)", "translateY(10px)"] }, { duration: 0.25, at: "<", easing: [0.55, 0.055, 0.675, 0.19] }],
			  [fromSlide.querySelector(".button-group"), { opacity: [1, 0], transform: ["translateY(0)", "translateY(20px)"] }, { duration: 0.25, at: "<", easing: [0.55, 0.055, 0.675, 0.19] }],
			  [fromSlide.querySelectorAll(".content-over-media > :is(video-media, svg), .content-over-media > picture img"), { opacity: [1, 0] }, { duration: 0.2, at: "-0.1", easing: [0.55, 0.055, 0.675, 0.19] }]
	      ]);
      }
  }
};

_setupListeners2 = new WeakSet();
setupListeners_fn2 = function() {
	if (this.allCells.length > 1) {
		if (this.adaptiveHeight) {
			this.addEventListener("carousel:settle", __privateMethod(this, _adaptHeight, adaptHeight_fn));
		}
	}
};

_onResize = new WeakSet();
onResize_fn = function() {
	if (this.adaptiveHeight) {
		__privateMethod(this, _adaptHeight, adaptHeight_fn).call(this);
	}
};

_adaptHeight = new WeakSet();
adaptHeight_fn = function() {
	this.style.maxHeight = null;
	this.style.maxHeight = `${this.selectedCell.clientHeight}px`;
	ScrollTrigger.refresh();
};

if (!window.customElements.get("featured-content-ghd")) {
	window.customElements.define("featured-content-ghd", FeaturedContentGHD);
}

export {
	FeaturedContentGHD
}